export default __webpack_public_path__ + "static/media/D3-3.bd824dd6.png";